// removed by extract-text-webpack-plugin
module.exports = {"homeScreen":"src-components-PrintDSWmsBarcode-styles__homeScreen--C4RL0","viewSwitcher":"src-components-PrintDSWmsBarcode-styles__viewSwitcher--1_X5r","active":"src-components-PrintDSWmsBarcode-styles__active--211PP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PrintDSWmsBarcode/styles.scss
// module id = 276
// module chunks = 0